import styles from './Footer.module.css'

function Footer() {
  return (
    <div className={`${styles.footer} ${styles.bgDarkBlue}`}>
      <div className={styles.container}>
        <div className={`${styles.copyright} ${styles.small2}`}>
          © Alex-logistic.com,2024.
          <br />
          Все права защищены.
        </div>
      </div>
      <a className={`${styles.linkTop} ${styles.linkto}`} href="#body">
        &lsaquo;<span>Наверх</span>
      </a>
    </div>
  )
}

export default Footer
